import { attachLoadingSpinner } from './utilities/loading-spinner';
import { ToSOverlay } from './tos-overlay';

// TODO: DRY this class so it's more generic to be able to proper work independently from a component and not just `c-download` specific. Needs changing in CSS and Templates as well.
export class LoadMore {
  constructor(node, contentType) {
    this.rootElement = node;
    this.contentType = contentType;
    this.downloadList = this.rootElement.closest('#downloadList').querySelector('.c-downloads__result-list');
    this.nextPage = this.rootElement.getAttribute('data-gs1-media-hub-more-items');
    this.maxPages = this.rootElement.getAttribute('data-gs1-media-hub-pages');

    this.activeTopicFilters = [];
    this.activeBranchFilters = [];
    this.activeLanguageFilters = [];
    this.activeFormatFilters = [];

    this.topicFilterSection = this.rootElement.closest('body').querySelector('.c-filter__topic');
    if (this.topicFilterSection) {
      this.activeTopicFilter = this.topicFilterSection.querySelectorAll('.c-form-element-checkbox:checked');
      this.activeTopicFilter.forEach((activeTopicFilter) => {
        this.activeTopicFilters.push(activeTopicFilter.value);
      });
    }
    this.branchFilterSection = this.rootElement.closest('body').querySelector('.c-filter__branch');
    if (this.branchFilterSection) {
      this.activeBranchFilter = this.branchFilterSection.querySelectorAll('.c-form-element-checkbox:checked');
      this.activeBranchFilter.forEach((activeBranchFilter) => {
        this.activeBranchFilters.push(activeBranchFilter.value);
      });
    }
    this.lanuageFilterSection = this.rootElement.closest('body').querySelector('.c-filter__language');
    if (this.lanuageFilterSection) {
      this.activeLanguageFilter = this.lanuageFilterSection.querySelectorAll('.c-form-element-checkbox:checked');
      this.activeLanguageFilter.forEach((activeLanguageFilter) => {
        this.activeLanguageFilters.push(activeLanguageFilter.value);
      });
    }
    this.formatFilterSection = this.rootElement.closest('body').querySelector('.c-filter__format');
    if (this.formatFilterSection) {
      this.activeFormatFilter = this.formatFilterSection.querySelectorAll('.c-form-element-checkbox:checked');
      this.activeFormatFilter.forEach((activeFormatFilter) => {
        this.activeFormatFilters.push(activeFormatFilter.value);
      });
    }
    this.downloadsGrid = this.downloadList.querySelector('.c-downloads-list__container');
    this.rootElement.addEventListener('click', this.onButtonClick.bind(this));
  }

  async onButtonClick() {

    let topicFilter = '', branchFilter = '', languageFilter = '', formatFilter = '';

    if ((this.activeTopicFilters.length > 0)) {
      this.activeTopicFilters.forEach((value) => {
        topicFilter += '&tx_gs1mediahub_downloads[topicCategory][]=' + value;
      });
    }
    if ((this.activeBranchFilters.length > 0)) {
      this.activeBranchFilters.forEach((value) => {
        branchFilter += '&tx_gs1mediahub_downloads[branchCategory][]=' + value;
      });
    }
    if ((this.activeLanguageFilters.length > 0)) {
      this.activeLanguageFilters.forEach((value) => {
        languageFilter += '&tx_gs1mediahub_downloads[languageCategory][]=' + value;
      });
    }
    if ((this.activeFormatFilters.length > 0)) {
      this.activeFormatFilters.forEach((value) => {
        formatFilter += '&tx_gs1mediahub_downloads[formatCategory][]=' + value;
      });
    }

    const currentLocation = new URLSearchParams(window.location.search);
    const hasSearchTerm = currentLocation.has('tx_gs1mediahub_downloads[searchTerm][0]');
    const getSearchTerm = (hasSearchTerm) ? currentLocation.get('tx_gs1mediahub_downloads[searchTerm][0]') : '';

    // TODO: Migrate this URL black magic fully to URLSearchParams
    const uri = `?tx_${this.contentType}[controller]=${this.contentType === 'gs1mediahub_downloads' ? 'ListView' : 'Images'}${topicFilter}${branchFilter}${languageFilter}${formatFilter}${(hasSearchTerm) ? `&tx_gs1mediahub_downloads[searchTerm][0]=${getSearchTerm}` : ''}&tx_${this.contentType}[currentPage]=${this.nextPage}`;
    const pageUrl = encodeURI(uri);

    this.currentParentElement = this.downloadsGrid.closest('.c-downloads-list').getAttribute('id');

    // Hide button and show spinner
    this.rootElement.insertAdjacentElement('afterend', attachLoadingSpinner(''));
    this.rootElement.style.display = 'none';

    await fetch(pageUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'text/html',
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
      },
    }).then((response) => {
      if (response.ok) {
        return response.text();
      }
    }).then(pageData => {
      this.nextPage++;
      const domParser = new DOMParser();
      const dom = domParser.parseFromString(pageData, 'text/html');
      const currentElement = dom.querySelector(`#${this.currentParentElement}`);
      const downloadGrid = currentElement.querySelector('.c-downloads__result-list');
      const downloadCards = downloadGrid.querySelectorAll('.c-card');
      downloadCards.forEach((downloadCard, cardNum) => {
        downloadCard.style.opacity = '0';
        this.downloadsGrid.insertAdjacentElement('beforeend', downloadCard);
        this.fadeIn(downloadCard, 250);
        if (cardNum === 0) {
          downloadCard.scrollIntoView( { behavior: 'smooth', block: 'start' });
        }
        if (this.nextPage > this.maxPages) {
          this.rootElement.remove();
        }

        if (downloadCard.hasAttribute('data-download-with-tos')) {
          new ToSOverlay(downloadCard);
        }
      });
    }).catch((error) => {
      console.error(error);
    });

    // Remove spinner and unhide button
    document.querySelector('.c-loading-spinner').remove();
    this.rootElement.style.display = 'block';
  }

  fadeIn(element, duration) {
    let start;

    function step(timestamp) {
      if (!start) {
        start = timestamp;
      }
      const opacity = (timestamp - start) / duration;
      element.style.opacity = opacity;
      if (opacity >= 1) {
        return;
      }
      window.requestAnimationFrame(step);
    }
    window.requestAnimationFrame(step);
  }
}

const loadMoreButtons = document.querySelectorAll('[data-gs1-media-hub-load-more]');
loadMoreButtons.forEach((loadMoreButton) => {
  const contentType = loadMoreButton.closest('[data-gs1-media-hub-load-more-type]').getAttribute('data-gs1-media-hub-load-more-type');
  new LoadMore(loadMoreButton, contentType);
});
